import type { EditorContentVersion } from '../types';

export function filterVersions(versions: EditorContentVersion[]): EditorContentVersion[] {
  const oneMinute = 1000 * 60;
  const oneHour = oneMinute * 60;
  const oneDay = oneHour * 24;
  const slotsTaken: Record<string, boolean> = {};

  return versions.filter((version) => {
    const editTime = new Date(version.time).getTime();
    const timeAgo = Date.now() - editTime;

    // show most recent update per day for updates older than a day
    //             ''          per hour            ''         an hour
    //             ''          per 5 minutes       ''         a minute
    let slot = 0;
    if (timeAgo > oneDay) slot = Math.floor(editTime / oneDay);
    else if (timeAgo > oneHour) slot = Math.floor(editTime / oneHour);
    else if (timeAgo > oneMinute) slot = Math.floor(editTime / (5 * oneMinute));

    // show only most recent update for updates younger than 1 minute
    const alreadyTaken = slotsTaken[slot];
    if (!alreadyTaken) slotsTaken[slot] = true;
    return !alreadyTaken;
  });
}
